module.exports = __webpack_public_path__ + "build/desktop/img/emirates-banner-main.52d91344e608bac6d762108f0cc40a28.webp";